import type { ExplorationFilter } from '../../types/exploration';

export function explorationFiltersEqual(a: ExplorationFilter, b: ExplorationFilter): boolean {
  if (a.type !== b.type) return false;
  if (a.type === 'capacity' && b.type === 'capacity') {
    return a.min === b.min && a.max === b.max;
  }
  if (a.type === 'tag' && b.type === 'tag') {
    return a.key === b.key && a.value === b.value;
  }
  if ('value' in a && 'value' in b) {
    return a.value === b.value;
  }
  return false;
}

export function removeExplorationFilter(
  filters: ExplorationFilter[],
  target: ExplorationFilter
): ExplorationFilter[] {
  return filters.filter((f) => !explorationFiltersEqual(f, target));
}

export function removeExplorationFilters(
  filters: ExplorationFilter[],
  targets: ExplorationFilter[]
): ExplorationFilter[] {
  if (!targets.length) return filters;
  return filters.filter((f) => !targets.some((t) => explorationFiltersEqual(f, t)));
}
